import Button from '@material-ui/core/Button'
import React, { Component } from 'react'
import { deviceType, isMobile, isTablet } from 'react-device-detect'
import { Link } from 'react-router-dom'
import WebFooter from '../../../source/WebScreen/WebFooter'
import '../Login.css'
import styles from '../LoginForm.module.css'

export class SignUpForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mobileNumber: ''
    }
  }
  checkRegistration = event => {
    this.props.checkRegistration(event)
    event.preventDefault()
    console.log(event)
  }

  handleChange1 = (event, type) => {
    this.props.handleChange1(event)
  }

  toggleShow = event => {
    this.props.toggleShow(event)
  }

  handleKeyUp(e) {
    if (e.keyCode == 9) {
      e.preventDefault()
    }
  }

  render() {
    return (
      <div>
        {deviceType == 'browser' && (isMobile == false || isMobile == 'false') && (isTablet == false || isTablet == 'false') ? (
          <div class="loginformnew">
            <form onSubmit={this.checkRegistration.bind(this)}>
            <div className={styles.loginform_flex_container}>
              {/* Left Panel: Image and Footer */}
              <div className={styles.loginform_left_panel}>
                <div className={styles.loginform_image_wrapper}>
                  <img src={require('../../../source/Images/Banner/welcome_image_desktop.jpg')} className={styles.loginform_main_image} alt="welcome" />
                </div>
                <div className={styles.loginform_footer}>
                  Copyright © 2019-2026 Universal Health Fellowship. All rights reserved. | Powered by CarynHealth<br />
                  Version 6.1.0
                </div>
              </div>
              {/* Right Panel: Form Content */}
              <div className={styles.loginform_right_panel}>
                <div className={styles.loginform_form_wrapper}>
                  <img src={require('../../../source/Images/Banner/logo.png')} className={styles.login_uhs_logo} alt="logo" />
                  <div className={styles.login_input_container}>
                  <div className={styles.check_registration_header}>
                    <div className={styles.check_registration_title}>Having trouble logging in?</div>
                    <div className={styles.check_registration_subtitle}>Let's check if your email has been registered on the portal.</div>
                  </div>

                  <input
                    className={["login_input_username", styles.loginform_input].join(' ')}
                    type="email"
                    name="email"
                    pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$"
                    required
                    onChange={this.handleChange1}
                    placeholder="Enter your email"
                    onKeyDown={this.handleKeyUp}
                  />

                  <Button type="submit" className={["login_button", styles.loginform_button].join(' ')}>
                    CHECK REGISTRATION
                  </Button>
                </div>
                <div className={styles.login_bottom_text}>
                  <div className={styles.login_bottom_subtext}>
                    Go back to{' '}
                    <Link to="/login">
                      <span className={styles.login_plese_text}>Sign In</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            </div>
            </form>
          </div>
        ) : (
          <div class="loginmobile">
            <div class="loginmobile_header">
              {/* <MenuIcon style={{ color: '#ffffff', marginRight: '20px' }} /> */}
              <div class="loginmobile_header_text">Member Portal</div>
            </div>

            <div className="loginmobile_container">
              <form onSubmit={this.checkRegistration.bind(this)}>
              <div className="loginmobile_image_container">
                <img src={require('../../../source/Images/Banner/welcome_image_desktop.jpg')} className="loginmobile_banner" />
                <img src={require('../../../source/Images/Banner/logo.png')} className="loginmobile_logo" />
              </div>

                <div class="loginmobile_input_container">
                  <input
                    type="email"
                    name="email"
                    pattern="^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$"
                    required
                    onChange={this.handleChange1}
                    placeholder="Enter your email"
                    class="loginmobile_input_username"
                  />

                  <Button type="submit" variant="contained" color="" class="loginmobile_button">
                    CHECK REGISTRATION
                  </Button>
                </div>

                <div class="loginmobile_bottom_text">
                  <div class="loginmobile_text_blue">Having trouble logging in?</div>
                  <div class="forgotmobile_text_details">
                    <div>Let’s check if your email has been registered </div>
                    <div>on the portal</div>
                  </div>
                  {/* <div class="loginmobile_bottom_subtext3"></div> */}
                  <div class="loginmobile_bottom_subtext2">
                    <div>
                      Go to
                      <Link to="/login">
                        <span class="loginmobile_please_check"> Sign In</span>
                      </Link>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    )
  }
}
export default SignUpForm
